import type { TemplateRef } from '@angular/core';
import type { ColumnAlign, DocumentItem } from '@document-explorer/core';

/** A column in the list view. Mirrors the React package exactly. */
export interface ColumnDef {
  key: string;
  label: string;
  sortable?: boolean;
  /**
   * Where this column's content sits. Falls back to the explorer's
   * `columnAlign`, then to `'left'`.
   */
  align?: ColumnAlign;
  /**
   * Use tabular numerals, so digits keep the same width and rows do not shift
   * as values change. This is about digits, not position — set `align` for
   * position.
   */
  numeric?: boolean;
  width?: string;
  optional?: boolean;
  /** Opt this column out of resizing when `resizableColumns` is on. */
  resizable?: boolean;
  /** Pixel floor for this column. Never goes below the global minimum. */
  minWidth?: number;
  /** Pixel ceiling for this column. */
  maxWidth?: number;
}

export interface ActionDef {
  id: string;
  label: string;
  visible?: (item: DocumentItem) => boolean;
  danger?: boolean;
}

export interface ActionsShorthand {
  view?: boolean;
  download?: boolean;
}

export type ActionsConfig = ActionsShorthand | ActionDef[];

export interface InteractionConfig {
  folderClick?: 'open' | 'select' | 'none';
  fileClick?: 'open' | 'select' | 'none';
  doubleClick?: 'open' | 'none';
}

/** The context handed to a consumer's `ng-template` slot. */
export interface ItemTemplateContext {
  $implicit: DocumentItem;
  item: DocumentItem;
}

export type ItemTemplate = TemplateRef<ItemTemplateContext>;

/** Click behaviour used when the consumer does not override it. */
export const DEFAULT_INTERACTION: Required<InteractionConfig> = {
  folderClick: 'open',
  fileClick: 'select',
  doubleClick: 'open',
};
